import { render, staticRenderFns } from "./DbList.vue?vue&type=template&id=3c7ef5b9&"
import script from "./DbList.vue?vue&type=script&lang=js&"
export * from "./DbList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports